var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitchLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "250px",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitch-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitch-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitch-seeklogo.com",
    transform: "translate(20.000000, 15.000000)",
    fill: "#5A3E85",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3476667,0 L0,38.2616667 L0,191.290001 L52.5836667,191.290001 L52.5836667,220 L81.2922001,220 L109.972134,191.290001 L153.004134,191.290001 L210.391867,133.9228 L210.391867,0 L14.3476667,0 Z M33.4627334,19.1187334 L191.268734,19.1187334 L191.268734,124.338133 L157.787667,157.8214 L105.195933,157.8214 L76.5240668,186.4918 L76.5240668,157.8214 L33.4627334,157.8214 L33.4627334,19.1187334 Z M86.06752,114.785513 L105.195787,114.785513 L105.195787,57.4007134 L86.06752,57.4007134 L86.06752,114.785513 Z M138.66292,114.785513 L157.78752,114.785513 L157.78752,57.4007134 L138.66292,57.4007134 L138.66292,114.785513 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchLogo);
export default __webpack_public_path__ + "static/media/twitch-logo.5145b9483fab4b2792429c7edcbe96f6.svg";
export { ForwardRef as ReactComponent };